import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import IcModalError from '../modal-error.svg';
import IcModalSuccess from '../modal-success.svg';
import { CustomHeroButton, ResponsiveModal, Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';

interface CodeVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  accountName: any;
}

const AccCreatedModal: React.FC<CodeVerificationModalProps> = ({
  isOpen,
  onClose,
  accountName,
}) => {
  const { t } = useTranslations();
  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose}>
      <ModalContent className="md:w-[25rem]">
        <ModalHeader className="flex items-center gap-2">
          <img src={IcModalSuccess} alt="Success" />
          <h3 className="text-lg font-medium">{t('createAccount.accCreated.title')}</h3>
        </ModalHeader>
        <ModalBody className="pt-3 px-4 md:px-6 pb-6">
          <Typography variant="body2">
            {t('createAccount.accCreated.messageBefore')}{' '}
            <span className="md:font-semibold">@{accountName}</span>{' '}
            {t('createAccount.accCreated.messageAfter')}
          </Typography>
        </ModalBody>
        <ModalFooter>
          <CustomHeroButton onPress={onClose} title={t('createAccount.buttons.continue')} />
        </ModalFooter>
      </ModalContent>
    </ResponsiveModal>
  );
};

export default AccCreatedModal;
